/**************
 Cart
 ***************/

// open cart
async function openCart(skipFetch = false) {
    
    if (cartSettings.use_rebuy) {
        // open rebuy cart and exit
        try {
            window.Rebuy.SmartCart.show();
        } catch (e) {
            document.addEventListener('rebuy:smartcart.ready', (event) => {
                window.Rebuy.SmartCart.show();
            });
        }
        return;
    }


    // open cart if not already open
    if (document.querySelector("#miniCart:not([open])")) {
        document.querySelector("#miniCart").showModal();
    }
    document.querySelector("body").classList.add("noScroll");

    // start loading animation
    document.querySelector("#miniCartContent").classList.add("loading");

    // hide empty cart section
    document.querySelector("#miniCartEmpty").classList.remove("active");

    // fetch cart
    if (skipFetch === false) {
        cart = await getCart();
    }

    // get cart item data
    const cartData = await fetch("/cart?view=supplemental-data")
        .then(response => response.json());
    const variantIDToAltImage = cartData.variantIDToAltImage;
    const variantIDToQuantity = cartData.variantIDToQuantity;

    // stop loading animation
    document.querySelector("#miniCartContent").classList.remove("loading");

    //  update cart count in header nav
    document.querySelector("#headerIconsCart span").textContent = `${cart.item_count}`;
    document.querySelector("#miniCartHeaderTitle span").textContent = `(${cart.item_count})`;

    // check for empty cart and EXIT
    if (cart.item_count === 0) {
        document.querySelector("#miniCartEmpty").classList.add("active");
        document.querySelector("#miniCartHeader").classList.remove("active");
        document.querySelector("#miniCartBody").classList.remove("active");
        document.querySelector("#miniCartBar").classList.remove("active");
        document.querySelector("#miniCartFooter").classList.remove("active");
        return;
    }

    // show main cart sections
    document.querySelector("#miniCartHeader").classList.add("active");
    document.querySelector("#miniCartBody").classList.add("active");
    document.querySelector("#miniCartBar").classList.add("active");
    document.querySelector("#miniCartFooter").classList.add("active");

    // check how many subscription items are in the cart, including quantity
    let subscriptionItems = 0;
    cart.items.forEach(item => {
        if (item.selling_plan_allocation) {
            subscriptionItems += item.quantity;
        }
    });

    // Free shipping for subscription
    if (cartSettings.free_shipping_method === "subscription") {
        if (subscriptionItems > 0) {
            document.querySelector("#miniCartHeaderShipping").innerHTML = "You've unlocked <b>FREE SHIPPING</b>";
            document.querySelector("#miniCartHeaderBarInner").classList.add("active");
        } else {
            document.querySelector("#miniCartHeaderShipping").innerHTML = "Upgrade to a subscription for <b>FREE SHIPPING</b>";
            document.querySelector("#miniCartHeaderBarInner").classList.remove("active");
        }
    }

    // Free shipping for price threshold
    if (cartSettings.free_shipping_method === "threshold") {
        let freeShippingThreshold = parseInt(cartSettings.free_shipping_threshold * 100);
        if (cart.total_price >= freeShippingThreshold) {
            document.querySelector("#miniCartBarShipping").innerHTML = "YOU'VE QUALIFIED FOR FREE SHIPPING!";
            document.querySelector("#miniCartBarTrackInner").classList.add("active");
        } else {
            document.querySelector("#miniCartBarShipping").innerHTML = `${price(freeShippingThreshold - cart.total_price)} AWAY FROM FREE SHIPPING!`;
            document.querySelector("#miniCartBarTrackInner").style.width = `${(cart.total_price / freeShippingThreshold) * 100}%`;
            document.querySelector("#miniCartBarTrackInner").classList.remove("active");
        }
    }

    // update cart price
    document.querySelector('#cartTotalSubtotalPrice').textContent = String(price(cart.total_price));

    // reset body container
    document.querySelectorAll(".miniCartBodyItem").forEach(element => element.remove());

    // append cart
    cart.items.forEach(function (item) {

        // quantity text
        function cleanTitle() {
            // check for quantity text metafield
            const cleanTitle = item.product_title.toLowerCase().replace(' - (4 pack)', "");
            return `<div class="miniCartBodyItemTitle title">${cleanTitle}</div>`;
        }

        // quantity text
        function imageHTML() {
            // check for alt image metafield
            if (variantIDToAltImage[item.product_id]) {
                return `<img class="miniCartBodyItemImage" src="${variantIDToAltImage[item.product_id]}&width=200" alt="${item.product_title}">`;
            } else {
                return `<img class="miniCartBodyItemImage" src="${item.image}&width=200" alt="${item.product_title}">`;
            }
        }

        // variant HTML
        function variantHTML() {
            // check for default variant
            if (item.variant_title === null) {
                return "";
            }
            return `<div class="miniCartBodyItemVariant title">${item.variant_title}</div>`;
        }

        // alt image
        function quantityHTML() {
            // check for  quantity text metafield
            if (variantIDToQuantity[item.product_id]) {
                return `<div class="miniCartBodyItemText">${variantIDToQuantity[item.product_id]}</div>`;
            } else {
                return ``;
            }
        }

        // subscription HTML
        function subscriptionHTML() {
            if (item.selling_plan_allocation) {
                return `<div class="miniCartBodyItemText">${item.selling_plan_allocation.selling_plan.name}</div>`;
            } else {
                return `<div class="miniCartBodyItemText">ONE TIME</div>`;
            }
        }

        // property HTML
        function propertiesHTML() {
            // check for any properties
            if (!item.properties && Object.keys(item.properties).length > 0) {
                return "";
            }

            // generate HTML for each item
            let HTML = `<div class="miniCartBodyItemText">`;
            for (const key in item.properties) {
                // check for link
                if (typeof item.properties[key] === "string" && item.properties[key].includes("https://")) {
                    HTML += `<a href="${item.properties[key]}" target="_blank">${key}</a><br>`;
                    continue;
                }

                // catch all
                HTML += `${key}: ${item.properties[key]}<br>`;
            }
            HTML += `</div>`;

            // return string
            return HTML;
        }

        // price HTML
        function priceHTML() {
            return price(item.line_price);
        }

        // insert item
        document.querySelector("#miniCartBody").insertAdjacentHTML("beforeend", `
            <div class="miniCartBodyItem" data-key="${item.key}">
                ${imageHTML()}
                <div  class="miniCartBodyItemContent">
                    <div class="miniCartBodyItemContentTop">  
                        ${cleanTitle()}
                        <div class="miniCartBodyItemContentTopRight">
                            <div class="miniCartBodyItemPrice">${priceHTML()}</div>
                            <button class="miniCartBodyItemRemove" title="remove item">
                                <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M0.923828 0.636475L7.36065 7.45466" stroke="black" stroke-width="1.02273" stroke-linecap="round"/>
                                    <path d="M6.98047 0.636475L0.543651 7.45466" stroke="black" stroke-width="1.02273" stroke-linecap="round"/>
                                </svg>
                            </button>
                        </div>
                    </div>
                    ${variantHTML()}
                    ${quantityHTML()}
                    ${subscriptionHTML()}
                    ${propertiesHTML()}
                    <div class="miniCartBodyItemQuantity">
                        <button class="miniCartBodyItemQuantityButton miniCartBodyItemQuantityMinus" title="minus">
                            <svg width="7" height="2" viewBox="0 0 7 2" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.36 1.584C0.184 1.584 0.056 1.456 0.056 1.296V0.912C0.056 0.736 0.184 0.608 0.36 0.608H6.472C6.648 0.608 6.776 0.736 6.776 0.912V1.296C6.776 1.456 6.648 1.584 6.472 1.584H0.36Z" fill="black"/>
</svg>

                        </button>
                        <div class="miniCartBodyItemQuantityCount">${item.quantity}</div>
                        <button class="miniCartBodyItemQuantityButton miniCartBodyItemQuantityPlus" title="plus">
                            <svg width="8" height="7" viewBox="0 0 8 7" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3.032 6.552V4.104H0.568C0.408 4.104 0.264 3.96 0.264 3.8V3.128C0.264 2.968 0.408 2.824 0.568 2.824H3.032V0.344C3.032 0.184 3.176 0.0559998 3.336 0.0559998H4.008C4.168 0.0559998 4.312 0.184 4.312 0.344V2.824H6.776C6.936 2.824 7.064 2.968 7.064 3.128V3.8C7.064 3.96 6.936 4.104 6.776 4.104H4.312V6.552C4.312 6.712 4.168 6.84 4.008 6.84H3.336C3.176 6.84 3.032 6.712 3.032 6.552Z" fill="black"/>
</svg>

                        </button>
                    </div>
                </div>
            </div>
        `);

    });

    // event listener for each line item
    document.querySelectorAll(`.miniCartBodyItem`).forEach(function (element) {
        // get key
        let key = element.dataset.key;

        // get current quantity
        let quantity = parseInt(element.querySelector(".miniCartBodyItemQuantityCount").textContent);

        // minus
        element.querySelector(".miniCartBodyItemQuantityMinus").addEventListener("click", function () {
            if (quantity === 1) {
                element.querySelector(".miniCartBodyItemRemove").click();
            } else {
                quantity--;
                updateCartItem();
            }
        });

        // plus
        element.querySelector(".miniCartBodyItemQuantityPlus").addEventListener("click", function () {
            quantity++;
            updateCartItem();
        });

        // remove
        element.querySelector(".miniCartBodyItemRemove").addEventListener("click", function () {
            quantity = 0;
            updateCartItem();
        });

        // update quantity function
        async function updateCartItem() {
            // update label
            element.querySelector(`.miniCartBodyItemQuantityCount`).textContent = quantity;

            // start loading animation
            document.querySelector("#miniCartContent").classList.add("loading");

            // update cart in shopify
            cart = await updateCart({
                updates: {
                    [key]: quantity
                }
            });

            // update active body
            await openCart(true);
        }

    });

}

// close event
document.querySelector("#miniCart").addEventListener("close", function () {
    document.querySelector("body").classList.remove("noScroll");
});

// close cart function
function closeCart() {
    document.querySelector('#miniCartContent').classList.add('close');
    // allow sliding animation
    setTimeout(() => {
        document.querySelector('#miniCartContent').classList.remove('close');
        document.querySelector("#miniCart").close();
    }, 500);
}

// open cart event listener
document.querySelectorAll(".openCart").forEach(function (element) {
    element.addEventListener("click", function (e) {
        e.preventDefault();
        openCart();
    });
});

// close cart event listener
document.querySelectorAll(".closeCart").forEach(function (element) {
    element.addEventListener("click", closeCart);
});

// close cart on overlay click
document.querySelector("#miniCart").addEventListener("click", function (e) {
    if (e.target === this) {
        closeCart();
    }
})

// register dialog
// dialogPolyfill.registerDialog(document.querySelector("#miniCart"));

// check is coming from the cart
// if (document.referrer.includes("/cart") && !window.location.href.includes("/cart")) {
//     openCart();
// }